import { FieldError } from '@roger/ui-components';
import type { WorksheetFindingSeverity } from './validationErrors';

/**
 * The save-time validation message under one worksheet input.
 *
 * Wraps the design system's `FieldError` so every worksheet field renders the
 * same copy, and so the message can be referenced by `aria-describedby`
 * (FieldError itself takes no id). Renders nothing when the field is clean.
 *
 * A `warning` finding (advisory — the claim can still be sent) renders amber
 * instead of FieldError's red, so it cannot be mistaken for a blocking error.
 *
 * `break-words` keeps a long message wrapping inside its grid column at ~390px
 * instead of widening the row and pushing the page into horizontal scroll.
 */
export function WorksheetFieldError({
  id,
  error,
  severity = 'error',
}: {
  id?: string;
  error?: string;
  severity?: WorksheetFindingSeverity;
}) {
  if (!error) return null;
  return (
    <span id={id}>
      <FieldError
        error={error}
        className={
          severity === 'warning' ? 'break-words text-amber-700' : 'break-words'
        }
      />
    </span>
  );
}
